import React, { useState } from 'react'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import {
  RiUserLine,
  RiBarChartHorizontalLine,
  RiLayoutMasonryLine,
  RiCloseLine,
  RiMenuLine,
  RiSearchLine,
  RiPagesLine,
  RiSafeLine,
} from 'react-icons/ri'
import { HiOutlineLightningBolt } from 'react-icons/hi'

import SearchModal from '@/components/app/SearchModal'
import Button from '@/components/app/uikit/Button'

function TopNav() {
  const router = useRouter()

  const [mobileNav, setMobileNav] = useState(false)
  const [searchOverlay, setSearchOverlay] = useState(false)

  const logoutUser = async () => {
    Cookies.remove('authed')
    router.push('/login')
  }

  return (
    <div className="sticky shadow-md top-0 bg-gray-900   z-50 flex-shrink-0  flex flex-col h-16 bg-white ">
      {searchOverlay && (
        <SearchModal closeModal={() => setSearchOverlay(false)} />
      )}
      <div className="flex-1 flex items-center justify-between md:container w-full md:max-w-7xl mx-auto px-2">
        <div className="flex items-center flex-shrink-0 mr-4">
          <div
            onClick={() => {
              setMobileNav(false)
              router.push('/dashboard')
            }}
            className="flex items-center hover:opacity-70 cursor-pointer"
          >
            <img
              className="h-6 lg:h-8 w-auto"
              src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
              alt="onepager"
            />
            <h2 className="ml-2 text-lg text-white lg:text-xl font-bold appTitleItem -mt-1">
              onepager
            </h2>
          </div>
        </div>

        {/* Mobile */}
        <div
          className="block md:hidden "
          style={{
            position: 'absolute',
            top: '22px',
            right: '20px',
            zIndex: 99,
          }}
        >
          <div
            onClick={() => {
              setMobileNav(!mobileNav)
            }}
          >
            {mobileNav && (
              <div>
                <RiCloseLine />
              </div>
            )}
            {!mobileNav && (
              <div>
                <RiMenuLine />
              </div>
            )}
          </div>
          {mobileNav && (
            <div
              className="bg-white p-6 w-full shadow-lg border-b border-gray-300"
              style={{
                position: 'fixed',
                top: '62px',
                left: '0',
                zIndex: 99,
              }}
            >
              <div
                onClick={() => {
                  setMobileNav(!mobileNav)
                  router.push('/workspace')
                }}
                className="bg-gray-900 rounded hover:bg-black hover:text-white font-bold mb-3 py-2 px-4 cursor-pointer flex items-center text-base"
              >
                <RiPagesLine className="mr-2" />
                <div>Onepagers</div>
              </div>

              <div
                onClick={() => {
                  setMobileNav(!mobileNav)
                  router.push('/workspace/collections')
                }}
                className="bg-gray-900 rounded hover:bg-black hover:text-white font-bold mb-3 py-2 px-4 cursor-pointer flex items-center text-base"
              >
                <RiBarChartHorizontalLine className="mr-2" />
                <div>Collections</div>
              </div>

              <div
                onClick={() => {
                  setMobileNav(!mobileNav)
                  router.push('/workspace/create-onepager')
                }}
                className="bg-gray-900 rounded hover:bg-black hover:text-white font-bold mb-3 py-2 px-4 cursor-pointer flex items-center text-base"
              >
                <RiLayoutMasonryLine className="mr-2" />
                <div>Templates</div>
              </div>
              <div
                onClick={() => {
                  setMobileNav(!mobileNav)
                  router.push('/workspace/integrations')
                }}
                className="bg-gray-900 rounded hover:bg-black hover:text-white font-bold mb-3 py-2 px-4 cursor-pointer flex items-center text-base"
              >
                <HiOutlineLightningBolt className="mr-2" />
                <div>Integrations</div>
              </div>

              <div
                onClick={() => {
                  setMobileNav(!mobileNav)
                  router.push('/workspace/account')
                }}
                className="bg-gray-900 rounded hover:bg-black hover:text-white font-bold mb-3 py-2 px-4 cursor-pointer flex items-center text-base"
              >
                <RiUserLine className="mr-2" />
                <div>Account</div>
              </div>
              <div
                onClick={logoutUser}
                className="bg-gray-900 rounded hover:bg-black hover:text-white font-bold mb-3 py-2 px-4 cursor-pointer flex items-center text-base"
              >
                <RiUserLine className="mr-2" />
                <div>Log out</div>
              </div>
            </div>
          )}
        </div>

        {/* Desktop */}
        <div className="flex items-center space-x-2">
          <Button
            text="Onepagers"
            icon={<RiPagesLine />}
            onClick={() => {
              router.push('/workspace')
            }}
            theme="light-gray"
            size="sm"
          />
          <Button
            text="Collections"
            icon={<RiMenuLine />}
            onClick={() => {
              router.push('/workspace/collections')
            }}
            theme="light-gray"
            size="sm"
          />
          <Button
            text="Templates"
            icon={<RiLayoutMasonryLine />}
            onClick={() => {
              router.push('/workspace/create-onepager')
            }}
            theme="light-gray"
            size="sm"
          />

          <Button
            text="Integrations"
            icon={<HiOutlineLightningBolt />}
            onClick={() => {
              router.push('/workspace/integrations')
            }}
            theme="light-gray"
            size="sm"
          />

          {/* <Button
            text="Vault"
            icon={<RiSafeLine />}
            onClick={() => {
              router.push('/vault')
            }}
            theme="light-gray"
            size="sm"
          /> */}

          <Button
            text=""
            icon={<RiUserLine />}
            onClick={() => {
              router.push('/workspace/account')
            }}
            theme="light-gray"
            size="sm"
          />

          {/* <Button
            icon={<RiSearchLine />}
            domId="navSearch"
            onClick={() => {
              setSearchOverlay(true)
            }}
            theme="light-gray"
            size="sm"
          /> */}
        </div>
      </div>
    </div>
  )
}

export default TopNav
